import * as o from "./components/index.mjs";
import t from "./foundations/index.mjs";
import { layerStyles as r } from "./layerStyles.mjs";
import { semanticTokens as e } from "./semanticTokens.mjs";
import i from "./styles.mjs";
import { textStyles as s } from "./textStyles.mjs";
const m = "ltr", n = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "odi"
}, d = {
  direction: m,
  ...t,
  components: {
    ...o
  },
  styles: i,
  config: n,
  semanticTokens: e,
  textStyles: s,
  layerStyles: r
};
export {
  d as theme
};
